import { paymentTierAmount } from "@/types/payments";

export const POLISH_AMOUNT = paymentTierAmount["CV Enhancement with AI"];

export function formatIdr(value: number) {
  return `Rp${new Intl.NumberFormat("id-ID").format(value)}`;
}

export const POLISH_PRICE_LABEL = formatIdr(POLISH_AMOUNT);
